// C2 · Cart style › "Prices without .00": removes a trailing ".00" (or ",00") from the prices the theme's own
// files write (cart drawer, cart page, search, product cards outside C2), also when the theme re-renders them
// (quantity change, cart update). "$789.00" -> "$789", "$1,147.00" -> "$1,147"; "$29.50" and "¥1,000" are kept.
// The theme's files are not edited; switching the setting off brings the theme's format back.
(() => {
  const ZEROS = /(\d)[.,]00(?!\d)/g;
  const PRICE = '[class*="price"], [class*="total"], [class*="money"], [class*="discount-value"]';

  const clean = (root) => {
    const els = root.nodeType === 1 ? [...(root.matches(PRICE) ? [root] : []), ...root.querySelectorAll(PRICE)] : [];
    els.forEach((el) => {
      const walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      for (let n = walk.nextNode(); n; n = walk.nextNode()) {
        if (ZEROS.test(n.nodeValue)) { ZEROS.lastIndex = 0; n.nodeValue = n.nodeValue.replace(ZEROS, '$1'); }
        ZEROS.lastIndex = 0;
      }
    });
  };

  let queued = new Set();
  const flush = () => { const q = queued; queued = new Set(); q.forEach((n) => n.isConnected && clean(n)); };
  const start = () => {
    clean(document.body);
    new MutationObserver((list) => {
      if (!queued.size) requestAnimationFrame(flush);
      list.forEach((m) => {
        if (m.type === 'characterData') { if (m.target.parentElement) queued.add(m.target.parentElement); }
        else m.addedNodes.forEach((n) => { if (n.nodeType === 1) queued.add(n); else if (n.parentElement) queued.add(n.parentElement); });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
